/**
 * 获取价格精度。（此处假定最小可变单位只存在一位非0数字）
 * @param {number} minTick - 最小可变单位
 *
 * @returns {number}
 */
export default function getPriceAccuracy(minTick) {
  if (minTick < 0.001) return 4
  if (minTick < 0.01) return 3
  if (minTick < 0.1) return 2
  if (minTick < 1) return 1
  return 0
}
